// assets/custom-addons.js — COMPLETE VERSION WITH DUPLICATE PREVENTION
(function () {
  'use strict';

  // SINGLETON CHECK - Prevent multiple instances
  if (window.__LouieAddonsInitialized) {
    console.log('[LouieAddons] Already initialized, skipping duplicate load');
    return;
  }
  window.__LouieAddonsInitialized = true;

  const SURCHARGE_VARIANT_MAP = {
    "1": 47236843733166, /* coreless */
    "6": 47302287229102, /* brass scissor clip */
    "8": 47275001774254, /* heavy duty brass swivel */
    "9": 47302395101358, /* stainless snap swivel */
    "10": 47275001544878, /* heavy duty nickel */
    "11": 47302466371758, /* stainless scissor clip */
    "13": 47301707202734, /* snap lock hook */
    "14": 47301680562350, /* brass bull clip */
    "18": 47301687378094 /* brass panic snap swivel */
  };

  const dbg = (...args) => { try { console.log.apply(console, ['[LouieAddons]'].concat(args)); } catch(e){} };

  // DUPLICATE PREVENTION VARIABLES
  let isProcessing = false;
  let lastProcessedTime = 0;
  const MIN_TIME_BETWEEN_ADDS = 2000; // 2 seconds minimum between adds

  // Score each form and pick the best: prefer the form that contains .louie-addons-wrapper
  function findBestProductForm() {
    const forms = Array.from(document.querySelectorAll('form'));
    if (!forms.length) {
      // If there are no <form> tags yet, also check for <product-form> web component wrappers
      const pf = document.querySelector('product-form');
      if (pf) {
        const inner = pf.querySelector('form');
        if (inner) return inner;
      }
      return null;
    }

    const scored = forms.map(f => {
      let score = 0;
      if (f.querySelector('.louie-addons-wrapper')) score += 50;
      const submitBtn = f.querySelector('button[type="submit"], input[type="submit"], [name="add"], .product-form__submit');
      if (submitBtn) score += 30;
      if (f.querySelector('input[name="id"]')) score += 10;
      // prefer forms with data-type attribute used by many themes
      if (f.getAttribute('data-type') === 'add-to-cart-form') score += 5;
      return { form: f, score };
    });

    scored.sort((a,b) => b.score - a.score);
    const best = scored[0];
    if (!best || best.score === 0) return null;
    return best.form;
  }

  // Wait for the form to appear in DOM (observes mutations)
  function waitForFormAndInit(initFn, timeoutMs = 10000) {
    let done = false;
    let observer = null;

    function tryInit() {
      if (done) return;
      const f = findBestProductForm();
      if (f) {
        // CHECK FOR DUPLICATE INITIALIZATION
        if (f.dataset.louieAddonsInit === 'true') {
          dbg('Form already initialized, skipping');
          done = true;
          if (observer) observer.disconnect();
          return;
        }
        
        // Mark form as initialized
        f.dataset.louieAddonsInit = 'true';
        done = true;
        if (observer) observer.disconnect();
        initFn(f);
      }
    }

    // immediate try
    tryInit();
    if (done) return;

    observer = new MutationObserver(tryInit);
    observer.observe(document.documentElement || document.body, { childList: true, subtree: true });

    setTimeout(() => {
      if (!done) {
        if (observer) observer.disconnect();
        const f = findBestProductForm();
        if (f && f.dataset.louieAddonsInit !== 'true') {
          f.dataset.louieAddonsInit = 'true';
          initFn(f);
        }
        else dbg('Timed out waiting for product form or already initialized.');
      }
    }, timeoutMs);
  }

  // Initialization when we have a chosen form element
  function initWithForm(productForm) {
    dbg('product form found:', productForm);

    // REMOVE ANY EXISTING LISTENERS (cleanup to prevent duplicates)
    const existingBtn = productForm.querySelector('[data-louie-btn="true"]');
    if (existingBtn) {
      const newBtn = existingBtn.cloneNode(true);
      existingBtn.parentNode.replaceChild(newBtn, existingBtn);
      dbg('Cleaned up existing button listeners');
    }

    let addBtn = productForm.querySelector('button[type="submit"], [name="add"], input[type="submit"], .product-form__submit');
    if (!addBtn) addBtn = document.querySelector('.product-form__submit, .add-to-cart, .shopify-payment-button__button, button[data-add-to-cart]');
    if (!addBtn) dbg('add button not found inside form — will still attach submit listener (fallback).');
    else {
      addBtn.dataset.louieBtn = 'true'; // Mark our button
      dbg('add button found:', addBtn);
    }

    let variantInput = productForm.querySelector('[name="id"]') || document.querySelector('input[name="id"]');
    if (!variantInput) dbg('variant input (name="id") not found in form — variant may be null.');

    // Fix for label clicks to ensure selection happens BEFORE form submission
    document.querySelectorAll('.louie-option-label').forEach(label => {
      if (label.dataset.louieLabel === 'true') return; // Already setup
      label.dataset.louieLabel = 'true';
      
      label.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const forId = this.getAttribute('for');
        const input = document.getElementById(forId);
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Update visual state immediately
          document.querySelectorAll(`input[name="${input.name}"] + .louie-option-label`).forEach(l => {
            l.classList.remove('selected');
          });
          this.classList.add('selected');
          
          console.log('[LouieAddons] Selected:', input.name, '=', input.value);
          
          // Update price immediately
          if (typeof updatePriceDisplays === 'function') {
            updatePriceDisplays();
          }
        }
      });
    });

    const productVariants = window.__LV_PRODUCT_VARIANTS || [];
    const VARIANT_MAP = {};
    (productVariants || []).forEach(v => { VARIANT_MAP[String(v.id)] = v; VARIANT_MAP[Number(v.id)] = v; });

    const PROPERTY_LABEL_MAP = {
      'louie_clip_type': 'Clip Add On',
      'louie_loop_style': 'Loop Style',
      'louie_addon_leadset': 'Add-On'
    };

    const MAIN_PRODUCT_TITLE = window.__LV_PRODUCT_TITLE || document.title || 'Product';

    function collectSurchargeSelections() {
      const selected = [];
      const ls = document.querySelector('input[name="louie_addon_leadset"]:checked');
      console.log('[Debug] Lead-set checked input:', ls);
      console.log('[Debug] Lead-set value:', ls ? ls.value : 'none');
      console.log('[Debug] Lead-set surcharge key:', ls ? ls.dataset.surchargeKey : 'none');
      
      if (ls && ls.dataset && ls.dataset.surchargeKey && ls.dataset.surchargeKey !== '0') selected.push({ key: ls.dataset.surchargeKey, label: ls.value });
      const clip = document.querySelector('input[name="louie_clip_type"]:checked');
      if (clip && clip.dataset && clip.dataset.surchargeKey && clip.dataset.surchargeKey !== '0') selected.push({ key: clip.dataset.surchargeKey, label: clip.value });
      const loop = document.querySelector('input[name="louie_loop_style"]:checked');
      if (loop && loop.dataset && loop.dataset.surchargeKey && loop.dataset.surchargeKey !== '0') selected.push({ key: loop.dataset.surchargeKey, label: loop.value });
      console.log('[Debug] Selected surcharges:', selected);
      return selected;
    }

    function getSelectedVariantPriceCents() {
      if (variantInput && variantInput.value && VARIANT_MAP[variantInput.value] && VARIANT_MAP[variantInput.value].price) return Number(VARIANT_MAP[variantInput.value].price);
      if (productVariants && productVariants.length && productVariants[0].price) return Number(productVariants[0].price);
      return 0;
    }
    
    function getSurchargeCents() {
      let total = 0;
      collectSurchargeSelections().forEach(s => {
        const price = Number(s.key);
        if (!isNaN(price)) total += price * 100;
      });
      return total;
    }
    
    function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

    function detectCurrencySuffix() {
      const selectors = [
        '.price-item--regular',
        '.product__price .price',
        '.product-single__price',
        '.price',
        '.product-price',
        '.product__price'
      ];

      for (const sel of selectors) {
        const el = document.querySelector(sel);
        if (!el) continue;

        const text = (el.textContent || '').trim();
        if (!text) continue;

        // Find suffix after the number
        const match = text.match(/(?:[\d,]+\.\d{2}|\d+)(\s*[A-Za-z]+.*)$/);
        if (match && match[1]) return match[1];
      }

      return ''; // default if nothing found
    }

    let CURRENCY_SUFFIX = detectCurrencySuffix();

    function formatMoneyWithSuffix(cents) {
      return '$' + (cents / 100).toFixed(2) + CURRENCY_SUFFIX;
    }

    function updatePriceDisplays() {
      CURRENCY_SUFFIX = detectCurrencySuffix(); // refresh suffix in case theme changes it

      const base = getSelectedVariantPriceCents();
      const surcharge = getSurchargeCents();
      const total = Number(base) + Number(surcharge);

      const formatted = formatMoneyWithSuffix(total);

      const selectors = [
        '.price-item--regular',
        '.product__price .price',
        '.product-single__price',
        '.price',
        '.product-price',
        '.product__price'
      ];

      selectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          el.textContent = formatted;
        });
      });
    }

    async function ajaxAdd(payload) {
      // Add selling_plan_id: "" to force bypass some checks
      const modifiedPayload = {
        ...payload,
        selling_plan: "",
        sections: "cart-notification-product,cart-notification-button,cart-icon-bubble"
      };
      
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(modifiedPayload)
      });
      
      const text = await res.text();
      let parsed = text;
      try { parsed = JSON.parse(text); } catch(e){/* not JSON */ }
      console.log('[LouieAddons] ajaxAdd response status:', res.status, 'body:', parsed);
      
      if (!res.ok) {
        const err = new Error('Add failed: ' + res.status + ' ' + (parsed && parsed.errors ? JSON.stringify(parsed) : text));
        err.responseBody = parsed;
        throw err;
      }
      return parsed;
    }

    function makeOrderGroupId() { return 'lvg_' + Date.now() + '_' + Math.floor(Math.random() * 10000); }

    async function handleAddToCart(e) {
      if (e && e.preventDefault) e.preventDefault();
      
      // DUPLICATE PREVENTION CHECKS
      const now = Date.now();
      if (isProcessing) {
        dbg('Already processing add to cart, ignoring duplicate click');
        return false;
      }
      
      if ((now - lastProcessedTime) < MIN_TIME_BETWEEN_ADDS) {
        dbg('Too soon after last add (' + (now - lastProcessedTime) + 'ms), preventing duplicate');
        return false;
      }
      
      // Set processing flag IMMEDIATELY
      isProcessing = true;
      lastProcessedTime = now;
      
      const variantId = variantInput && variantInput.value ? variantInput.value : null;
      if (!variantId) {
        alert('Please select a product variant. The theme may not render a variant input name="id".');
        isProcessing = false; // Reset flag
        return false;
      }

      // Store original button text
      const originalBtnText = addBtn ? addBtn.textContent : 'Add to Cart';
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
      }

      const orderGroupId = makeOrderGroupId();

      try {
        const properties = {};
        productForm.querySelectorAll('input[name^="properties"], textarea[name^="properties"]').forEach(inp => {
          const m = inp.name.match(/^properties\[(.*)\]$/);
          if (!m) return;
          if (inp.type === 'radio') { if (inp.checked) properties[m[1]] = inp.value; }
          else if (inp.value && inp.value.trim() !== '') properties[m[1]] = inp.value.trim();
        });

        ['louie_clip_type','louie_loop_style','louie_addon_leadset'].forEach(name => {
          const i = productForm.querySelector(`input[name="${name}"]:checked`);
          if (i) {
            const key = PROPERTY_LABEL_MAP[name] || name;
            properties[key] = i.value;
          }
        });

        properties['_lv_order_group'] = orderGroupId;

        dbg('Adding main variant', variantId, 'with properties', properties);
        const mainAddResponse = await ajaxAdd({ id: variantId, quantity: 1, properties: properties });

        const surcharges = collectSurchargeSelections();
        dbg('Surcharges to add:', surcharges);

        for (const s of surcharges) {
          const surchargeVariantId = SURCHARGE_VARIANT_MAP[String(s.key)];
          if (!surchargeVariantId) {
            console.warn('Louievale: no mapping for surcharge key', s.key);
            continue;
          }

          const mainVariantTitle = (VARIANT_MAP && VARIANT_MAP[String(variantId)] && VARIANT_MAP[String(variantId)].title) ? VARIANT_MAP[String(variantId)].title : '';
          const surchargeForLabel = (MAIN_PRODUCT_TITLE || document.title || 'Product') + (mainVariantTitle ? (' — ' + mainVariantTitle) : '');

          try {
            await ajaxAdd({
              id: surchargeVariantId,
              quantity: 1,
              properties: {
                '_lv_addon': 'true',
                '_lv_order_group': orderGroupId,
                'Surcharge for': surchargeForLabel,
              }
            });
          } catch (err) {
            console.warn('Louievale: failed to add surcharge', surchargeVariantId, ' — continuing. Error:', err);
            try {
              const banner = document.createElement('div');
              banner.style = 'background:#FFF5E6;border-left:4px solid #A67C59;padding:8px;margin:8px 0;font-size:13px;';
              banner.textContent = 'Note: an add-on could not be added to your cart and was skipped. Please contact us if you expected an add-on.';
              const formParent = productForm || document.querySelector('.product__info-container');
              formParent && formParent.prepend(banner);
              setTimeout(()=>banner.remove(), 8000);
            } catch(e){}
            continue;
          }
        }

        // Update cart bubble and trigger notification
        setTimeout(async () => {
          try {
            // Fetch fresh cart data
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();
            
            // Update cart count in multiple places
            const countElements = document.querySelectorAll(
              '.cart-count, .cart-count-bubble span, [data-cart-count], #CartCount, .site-header__cart-count'
            );
            countElements.forEach(el => {
              el.textContent = cart.item_count;
            });
            
            // Show cart bubble
            const bubble = document.querySelector('.cart-count-bubble');
            if (bubble) {
              bubble.classList.remove('hidden');
              bubble.style.display = '';
              const spans = bubble.querySelectorAll('span');
              spans.forEach(span => {
                if (span.getAttribute('aria-hidden') === 'true' || !span.classList.contains('visually-hidden')) {
                  span.textContent = cart.item_count;
                }
              });
            }
            
            // Trigger cart notification popup - Dawn theme specific
            const cartNotification = document.querySelector('cart-notification');
            if (cartNotification) {
              // First make it visible
              cartNotification.classList.add('animate', 'active');
              cartNotification.style.display = 'block';
              
              // If it has a specific open method, use it
              if (typeof cartNotification.open === 'function') {
                cartNotification.open();
              }
              
              // Fetch the sections to update the notification content
              const sectionsRes = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                  id: variantId,
                  quantity: 0, // 0 quantity just to get sections without adding again
                  sections: 'cart-notification-product,cart-notification-button'
                })
              }).catch(() => null);
              
              if (sectionsRes && sectionsRes.ok) {
                const data = await sectionsRes.json();
                if (data.sections && cartNotification.renderContents) {
                  cartNotification.renderContents({sections: data.sections});
                }
              }
              
              // DON'T auto-hide - user must close manually
              // Remove any existing auto-hide timeouts
              if (cartNotification._hideTimeout) {
                clearTimeout(cartNotification._hideTimeout);
              }
            }
            
            // Dispatch events for other scripts
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            
          } catch(err) {
            console.error('Error updating cart display:', err);
          }
        }, 300); // Slight delay to ensure all items are added

      } catch (err) {
        console.error('Louievale add flow error:', err);
        alert('There was an error adding the item(s) to cart. Please try again.');
      } finally {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = originalBtnText;
        }
        // Reset processing flag after a delay to ensure everything is done
        setTimeout(() => {
          isProcessing = false;
        }, 1000);
      }
      
      return false; // Prevent default form submission
    }

    // SINGLE EVENT LISTENER ATTACHMENT (prevent duplicates)
    if (addBtn && !addBtn.dataset.louieListenerAttached) {
      // Remove any existing listener by cloning
      const newBtn = addBtn.cloneNode(true);
      addBtn.parentNode.replaceChild(newBtn, addBtn);
      addBtn = newBtn;
      
      // Mark and attach new listener
      addBtn.dataset.louieListenerAttached = 'true';
      addBtn.addEventListener('click', handleAddToCart);
      dbg('Attached click listener to add button');
    }
    
    // FORM SUBMIT HANDLER (with duplicate prevention)
    const formSubmitHandler = function(ev) {
      // Only handle if this is our product form
      if (ev.target === productForm || ev.currentTarget === productForm) {
        ev.preventDefault();
        ev.stopPropagation();
        handleAddToCart(ev);
      }
      return false;
    };
    
    // Remove old listener and add new one
    productForm.removeEventListener('submit', productForm._louieSubmitHandler);
    productForm._louieSubmitHandler = formSubmitHandler;
    productForm.addEventListener('submit', formSubmitHandler);

    // PRICE UPDATE SYSTEM
    (function () {
      const PRICE_UPDATE_DEBOUNCE_MS = 350;
      let _priceUpdateTimer = null, _observerPaused = false, _priceObserver = null;

      function schedulePriceUpdate(immediate = false) {
        if (immediate) {
          if (_priceUpdateTimer) { clearTimeout(_priceUpdateTimer); _priceUpdateTimer = null; }
          _observerPaused = true;
          try { updatePriceDisplays(); } finally { setTimeout(()=>{ _observerPaused = false; }, 60); }
          return;
        }
        if (_priceUpdateTimer) clearTimeout(_priceUpdateTimer);
        _observerPaused = true;
        _priceUpdateTimer = setTimeout(() => {
          _priceUpdateTimer = null;
          try { updatePriceDisplays(); } finally { setTimeout(()=>{ _observerPaused = false; }, 60); }
        }, PRICE_UPDATE_DEBOUNCE_MS);
      }

      function doPriceUpdateNow() { schedulePriceUpdate(true); }

      // attach handlers with a mutation observer on a safe root element (no Liquid here)
      function attachPriceUpdateHooksImproved(productForm, variantInput) {
        // add-on radios -> update immediately
        document.querySelectorAll(
          'input[name="louie_clip_type"], input[name="louie_loop_style"], input[name="louie_addon_leadset"]'
        ).forEach(i => i.addEventListener('change', () => schedulePriceUpdate(true)));

        // variant changes -> schedule (debounced)
        if (variantInput) variantInput.addEventListener('change', () => schedulePriceUpdate(false));
        document.addEventListener('variant:change', () => schedulePriceUpdate(false));
        document.addEventListener('variantChange', () => schedulePriceUpdate(false));

        // choose priceRoot prioritizing elements inside the product form or product info
        let priceRoot = null;
        try {
          priceRoot = productForm.querySelector('[id^="price-"], .product__price, .product__info-container, .product-form__buttons') ||
                      document.querySelector('[id^="price-"], .product__price, .product__info-container') ||
                      document.body;
        } catch (err) {
          priceRoot = document.body;
        }

        // attach mutation observer but ignore while paused
        if (_priceObserver) { try{ _priceObserver.disconnect(); }catch(e){}; _priceObserver = null; }
        _priceObserver = new MutationObserver((muts) => { if (!_observerPaused) schedulePriceUpdate(false); });
        _priceObserver.observe(priceRoot, { subtree: true, childList: true, characterData: true });

        // initial update (small delay so theme can settle)
        setTimeout(() => schedulePriceUpdate(false), 10);

        // return helpers for debugging if needed
        return {
          schedulePriceUpdate,
          doPriceUpdateNow,
          _getObserverPaused: () => _observerPaused
        };
      }

      try {
        attachPriceUpdateHooksImproved(productForm, variantInput);
      } catch (e) {
        dbg('attachPriceUpdateHooksImproved failed to initialize:', e);
      }
    })();

    setTimeout(updatePriceDisplays, 0);
    dbg('Louievale add-ons: initialized.');
  }

  // Single initialization with protection
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForFormAndInit(initWithForm, 10000);
    }, { once: true }); // Use once: true to prevent duplicate listeners
  } else {
    waitForFormAndInit(initWithForm, 10000);
  }
})();

// After successful add to cart
if (window.accountDashboard) {
  window.accountDashboard.trackActivity('cart_add', `Added ${MAIN_PRODUCT_TITLE} to cart`);
}